export default () => (
  /**
   * Icone de confirmação.
   * Responsavel por concluir/criar.
   * Encontrado nas ferramentas de inserir coordenadas e inserir geometrias.
   */
  <svg
    width="17"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.73821 13C6.41903 13 6.11187 12.8735 5.88512 12.6468L1.06034 7.82198C0.58926 7.35062 0.58926 6.58717 1.06034 6.11608C1.53171 5.645 2.29516 5.645 2.76625 6.11608L6.66756 10.0174L14.8469 0.423419C15.2792 -0.0828504 16.0401 -0.144005 16.5475 0.287985C17.0543 0.720254 17.1149 1.48175 16.6829 1.98858L7.65608 12.5761C7.43771 12.8322 7.12245 12.9855 6.78596 12.9989C6.77004 12.9994 6.75413 13 6.73821 13Z"
      fill="#BEC7DC"
    />
  </svg>
);
